// These versioned derivatives are only used by muted decorative video players.
// Exact CMS identities keep replacement uploads on their original source URL.
const derivatives = new Map([
  ["https://cmsad.digifist.com/uploads/hero_video_9c23785a60.mp4", "/media/hero_video_9c23785a60-web-v1.mp4"],
  ["https://cmsad.digifist.com/uploads/video_blackbg_8e978e8546.mp4", "/media/video_blackbg_8e978e8546-web-v1.mp4"],
]);

function getDecorativeVideoSource(source) {
  return derivatives.get(source) || source;
}

module.exports = { getDecorativeVideoSource };
